import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdb53f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-pfizer-footer-categories hd-container" }
const _hoisted_2 = { class: "hd-pfizer-footer-categories__section" }
const _hoisted_3 = { class: "hd-pfizer-footer-categories__section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "anchor", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_base_image_svg, {
      class: "hd-pfizer-footer-categories__logo",
      source: require('!html-loader!@/plugins/pfizer/ui/assets/logos/svgs/pfizer-hospital-logo.svg')
    }, null, 8, ["source"])
  ]))
}